import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './SelectMenu.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      ref: "menu",
      staticClass: "select-menu",
      attrs: { tabindex: "-1" },
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "select-menu-inner" },
        [
          _c("Tree", {
            attrs: {
              value: _vm.selected,
              nodes: _vm.options,
              "current-suggestion-id": _vm.currentSuggestionId,
              "expand-level": 2,
              search: _vm.search
            },
            on: { input: _vm.onOptionSelected }
          }),
          _vm._v(" "),
          !_vm.hasSuggestions
            ? _c("div", { staticClass: "no-options" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      !_vm.containsQuery && _vm.async
                        ? _vm.placeholder
                        : _vm.noOptionsMessage
                    ) +
                    "\n        "
                )
              ])
            : _vm._e()
        ],
        1
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-e848368e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/TreeSelect/SelectMenu.vue.js